import { getConfig } from '@cian/config/browser';
import * as R from 'ramda';
import { FILTERS } from '../../constants/filters';
import { TSutochnoRegionType } from '../../types/sutochnoPilot';
import { FDealType, FOfferType } from '../../utils/category';

export const FILTERS_TYPES: { dealType: FDealType; offerType: FOfferType; list: (keyof typeof FILTERS)[] }[] = [
  {
    dealType: FDealType.Any,
    offerType: FOfferType.Flat,
    list: ['offerType', 'roomType', 'price', 'geo'],
  },
  {
    dealType: FDealType.Any,
    offerType: FOfferType.Urban & ~FOfferType.Flat,
    list: ['offerType', 'price', 'geo'],
  },
  {
    dealType: FDealType.Sale,
    offerType: FOfferType.Suburban,
    list: ['offerType', 'posessor', 'price', 'geo'],
  },
  {
    dealType: FDealType.RentLongterm,
    offerType: FOfferType.Suburban,
    list: ['offerType', 'price', 'geo'],
  },
  {
    dealType: FDealType.RentDaily,
    offerType: FOfferType.Suburban,
    list: ['offerType', 'bedrooms', 'price', 'geo'],
  },
  {
    dealType: FDealType.Sale | FDealType.RentLongterm,
    offerType: FOfferType.Commercial & ~FOfferType.CommercialLand & ~FOfferType.Coworking & ~FOfferType.Business,
    list: ['offerType', 'price', 'area', 'geo'],
  },
  {
    dealType: FDealType.Any,
    offerType: FOfferType.CommercialLand,
    list: ['offerType', 'price', 'landArea', 'geo'],
  },
  {
    dealType: FDealType.Rent,
    offerType: FOfferType.Coworking,
    list: ['offerType', 'coworkingOfferType', 'workplaceCount', 'coworkingPrice', 'geo'],
  },
  {
    dealType: FDealType.Sale,
    offerType: FOfferType.Business,
    list: ['offerType', 'specialtyTypes', 'price', 'geo'],
  },
  {
    dealType: FDealType.Rent,
    offerType: FOfferType.Business,
    list: ['offerType', 'price', 'area', 'geo'],
  },
];

/**
 * @todo Удалить блок с RS
 * @description Данный функционал появился в задаче CD-112138, будет удалён в задаче CD-112220
 */
{
  let enabled: null | boolean = null;

  Object.defineProperty(
    FILTERS_TYPES.find(el =>
      R.equals(el, {
        dealType: FDealType.Sale,
        offerType: FOfferType.Business,
        list: ['offerType', 'specialtyTypes', 'price', 'geo'],
      }),
    ) ?? {},
    'list',
    {
      get() {
        if (enabled === null) {
          enabled = !!getConfig().get<boolean>('Commercial.Business.V2.Enabled');
        }

        if (enabled) {
          return ['offerType', 'specialtyTypes', 'price', 'geo'];
        }

        return ['offerType', 'price', 'area', 'geo'];
      },
    },
  );
}

interface IGetFiltersListParams {
  dealType: FDealType;
  offerType: FOfferType;
  isSutochnoPilotEnabled: boolean;
  sutochnoRegionType: TSutochnoRegionType;
}

export function getFiltersList(params: IGetFiltersListParams): Array<keyof typeof FILTERS> {
  const { dealType, offerType, isSutochnoPilotEnabled, sutochnoRegionType } = params;

  if (isSutochnoPilotEnabled && sutochnoRegionType === 'empty') {
    return ['geo', 'refineDetails'];
  }

  if (isSutochnoPilotEnabled && sutochnoRegionType === 'target') {
    return ['geo', 'guests', 'departureDates'];
  }

  const typeList = FILTERS_TYPES.find(t => (t.dealType & dealType) !== 0 && (t.offerType & offerType) !== 0)?.list;

  if (isSutochnoPilotEnabled && sutochnoRegionType === 'nonTarget' && typeList) {
    const geoFilterIndex = typeList.findIndex(filter => filter === 'geo');

    // в пилоте гео отображается на первом месте
    return geoFilterIndex === -1 ? typeList : R.move(geoFilterIndex, 0, typeList);
  }

  return typeList || <Array<keyof typeof FILTERS>>[];
}
